import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import Button, { ButtonVariant } from '@/components/button';
import PasswordInput from '@/components/input/passwordInput';
import TextInput from '@/components/input/textInput';
import Typography from '@/components/typography';
import { AUTH_ACTIONS } from '@/constants/constants';

export const forgotPasswordText = 'Forgot Password?';

export type StepTwoFormData = {
  email: string;
  password: string;
};

const schema = yup.object({
  email: yup
    .string()
    .email('Must be a valid email')
    .required('This is a required field'),
  password: yup.string().required('This is a required field'),
});

type Props = {
  formId: string;
  isLoading: boolean;
  email: string;
  setEmail: (value: string) => void;
  handleOnSubmit: (data: StepTwoFormData) => void;
  goToForgotPassword: () => void;
};

const LoginStepTwoForm: React.FC<Props> = ({
  formId,
  isLoading,
  email,
  setEmail,
  handleOnSubmit,
  goToForgotPassword,
}) => {
  const initialValue: StepTwoFormData = {
    email,
    password: '',
  };

  const { handleSubmit, control, watch } = useForm({
    defaultValues: initialValue,
    resolver: yupResolver(schema),
  });

  const stepTwoEmail = watch('email');

  useEffect(() => {
    setEmail(stepTwoEmail);
  }, [setEmail, stepTwoEmail]);

  return (
    <form id={formId} onSubmit={handleSubmit(handleOnSubmit)}>
      <TextInput
        required
        className="w-full"
        control={control}
        label="Email"
        name="email"
        placeholder="Email"
      />
      <PasswordInput
        required
        className="w-full"
        control={control}
        label="Password"
        name="password"
        placeholder="Password"
        type="password"
      />

      <div className="flex justify-end">
        <button type="button" onClick={goToForgotPassword}>
          <Typography className="text-green-50" variant="body3">
            {forgotPasswordText}
          </Typography>
        </button>
      </div>

      <div className="flex flex-col gap-y-4">
        <Button
          form={formId}
          isLoading={isLoading}
          type="submit"
          variant={ButtonVariant.PRIMARY}
        >
          {AUTH_ACTIONS.LOGIN}
        </Button>
      </div>
    </form>
  );
};

export default LoginStepTwoForm;
